import {useInView} from '@aboutyou/ui-components';
import {useCallback, useRef, useState} from 'react';
import {useRectEffect} from 'react-viewport-utils';

export const useSearchBarDisplayState = () => {
  const searchInputRef = useRef<HTMLInputElement | null>(null);

  const [isSearchInTabletMode, setIsSearchInTabletMode] = useState(false);
  const [isSearchBarExpanded, setIsSearchBarExpanded] = useState(false);

  const {ref: searchWrapperRef, inView: isSearchWrapperInView} =
    useInView<HTMLDivElement>({
      initialInView: true,
      threshold: 0.1,
    });

  useRectEffect(
    rect => {
      if (rect) {
        setIsSearchInTabletMode(rect?.width < 180);
      }
    },
    searchWrapperRef,
    {priority: 'low'},
  );

  const expandSearchBar = useCallback(() => {
    if (isSearchInTabletMode) {
      setIsSearchBarExpanded(true);
    }
  }, [isSearchInTabletMode]);

  const collapseSearchBar = () => {
    setIsSearchBarExpanded(false);
  };

  const handleStickySearchIconClick = useCallback(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });

    expandSearchBar();
    searchInputRef.current?.focus({preventScroll: true});
  }, [expandSearchBar]);

  return {
    searchInputRef,
    isSearchInTabletMode,
    isSearchBarExpanded,
    expandSearchBar,
    collapseSearchBar,
    searchWrapperRef,
    handleStickySearchIconClick,
    showStickyHeaderSearchIcon: isSearchWrapperInView === false,
  };
};
